import { useMemo } from "react";
import { DetailsList } from "../../../components/DetailsList";
import { compact } from "lodash-es";

const useUiPathBotAutomationDetails = (automation) => {
  return useMemo(
    () =>
      compact([
        { label: "Vendor", value: automation.vendor },
        { label: "Code groups", value: automation.codeGroups.map((v) => v.name) },
        { label: "Payor names", value: automation.payorNames },
        { label: "Benefit Management Portal", value: automation.benefitManagementPortal.name },
        { label: "Bot Type", value: automation.uiPathBotType },
        automation.vendor === "uipath" ? { label: "Folder Name", value: automation.uiPathFolderName } : null,
        { label: "Automation Name", value: automation.uiPathReleaseName },
        { label: "Enabled", value: automation.enabled },
      ]),
    [
      automation.vendor,
      automation.codeGroups,
      automation.payorNames,
      automation.benefitManagementPortal.name,
      automation.uiPathBotType,
      automation.uiPathFolderName,
      automation.uiPathReleaseName,
      automation.enabled,
    ]
  );
};

export const UiPathBotAutomationReadOnly = ({ automation }) => {
  const values = useUiPathBotAutomationDetails(automation);
  return <DetailsList values={values} />;
};
